export const data = [
  {
    image: 'Indigo',
    caption: 'Indigo Design<br />Silver Award 2018',
    link: 'https://www.indigoawards.com/winners/549',
  },
  {
    image: 'CSSReel',
    caption: 'CSS REEL<br />Winner',
    link: 'http://cssreel.com/Website/teal-workspace-by-chilid',
  },
  {
    image: 'Certificate',
    caption: '2x Mobile<br />Excellence',
    link: 'https://www.awwwards.com/Boldare/awards',
  },
  {
    image: 'Honorable',
    caption: '10x Honorable<br />Mentions',
    link: 'https://www.awwwards.com/Boldare/awards',
  },
  { image: 'GWA', caption: 'German Web<br />Award', link: '' },
];
